<wiz-hgroup width="100%" height="100%" verticalAlign="center" style="padding-left:5px; padding-right:5px">
     <wiz-group width="100%" height="100%">
          <wiz-image  
          tabindex="0"
          width="50px"
          height="50px"
          class="img-picker img-freestyle"
          [useHandCursor]="true"
          [blobid]="item?.blobId"
          [sourceObservable]="getBlobObs(item?.blobId)"
          thumb="true"
          style="pointer-events: none;">
        </wiz-image>
        <!-- <div style='z-index: 100; width:100%; height:100%; cursor: pointer;'></div> -->
        <div style='z-index: 100; width:100%; height:100%; cursor: pointer;'></div>
      </wiz-group>

      <wiz-icon #iconUp *ngIf="mayUp()" [wizTooltip]="'$.vision.step.move.previous.$'" (click)="doUp($event)">arrow-up</wiz-icon>
      <wiz-icon #iconDown *ngIf="mayDown()" [wizTooltip]="'$.vision.step.move.next.$'"  (click)="doDown($event)">arrow-down</wiz-icon>
  
</wiz-hgroup>